import React from "react"
import Image from '../general/Image'
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";

export function PartnerSection({ section }) {
	return (
		<section
			className="partners eva-bg-inst-500 container-fluid"
			style={{ backgroundColor: section.body?.backgroundColor }}
		>
			<div className="container">
				<div className="blocks eva-text-center">

					<Typography variant="title" size={4} asChild
						className="eva-margin-bottom-1"
						style={{ color: section.body?.textColor }}
					>
            <p>{section.body?.partnersTitle}</p>
          </Typography>

					<Typography variant="body" size={1} asChild
						className="eva-margin-bottom-4"
						style={{ color: section.body?.textColor }}	
					>
						<p>{section.body?.partnersDescription}</p>
        	</Typography>

				</div>
				<div className="logos">
					{section.body?.partners.map((partner, index) => (
						<a
							key={index}
							href={partner.urlPartner}
							target="_self"
							rel="noreferrer"
							style={{ maxWidth: "160px" }}
							className="image"
						>
							<Image
								remoteImage={partner.remoteImagePartner}
								fallbackImageUrl={partner.imageUrl}
								alt=""
							/>
						</a>
					))}
				</div>
			</div>
		</section>
	)
}
